import { render } from "./TopPage.vue?vue&type=template&id=64a961ac&scoped=true"
import script from "./TopPage.vue?vue&type=script&lang=js"
export * from "./TopPage.vue?vue&type=script&lang=js"

import "./TopPage.vue?vue&type=style&index=0&id=64a961ac&scoped=true&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a961ac"]])

export default __exports__